import React from 'react';
import Layout from '../components/layout/Layout';
import { Shield, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
    return (
        <Layout>
            <div className="max-w-4xl mx-auto py-8">
                {/* Header */}
                <div className="mb-12">
                    <Link to="/" className="inline-flex items-center text-zinc-500 hover:text-primary mb-6 font-mono text-sm">
                        <ArrowLeft size={16} className="mr-2" /> Volver al inicio
                    </Link>
                    <div className="flex items-center gap-4 mb-4">
                        <Shield className="text-primary" size={32} />
                        <h1 className="text-4xl font-display font-bold text-white">Aviso de Privacidad</h1>
                    </div>
                    <p className="text-zinc-500 font-mono text-sm">Última actualización: Enero 2026</p>
                </div>

                {/* Content */}
                <div className="prose prose-invert max-w-none space-y-8">
                    <section className="bg-surface border border-zinc-800 rounded-xl p-8">
                        <h2 className="text-xl font-bold text-white mb-4">1. Responsable del Tratamiento</h2>
                        <p className="text-zinc-400 leading-relaxed">
                            <strong className="text-white">Instituto de Innovación Iztacalco A.C.</strong> ("i³", "nosotros")
                            con domicilio en Iztacalco, Ciudad de México, es responsable del tratamiento de sus datos personales
                            de conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.
                        </p>
                    </section>

                    <section className="bg-surface border border-zinc-800 rounded-xl p-8">
                        <h2 className="text-xl font-bold text-white mb-4">2. Datos que Recopilamos</h2>
                        <p className="text-zinc-400 leading-relaxed mb-4">Este sitio web recopila:</p>

                        <div className="mb-6">
                            <h3 className="text-white font-semibold mb-2">Datos de Registro (voluntarios)</h3>
                            <ul className="list-disc list-inside text-zinc-400 space-y-2">
                                <li><strong className="text-white">Nombre:</strong> Para identificación y comunicación personalizada</li>
                                <li><strong className="text-white">Correo electrónico:</strong> Para envío de actualizaciones y comunicaciones</li>
                                <li><strong className="text-white">WhatsApp:</strong> Para comunicación directa sobre eventos y programas</li>
                                <li><strong className="text-white">Colonia:</strong> Para segmentar información relevante a tu zona</li>
                                <li><strong className="text-white">Área de interés:</strong> Para personalizar contenido (Bootcamp, Transparencia, Hidrosensorial, etc.)</li>
                                <li><strong className="text-white">Mensaje opcional:</strong> Comentarios adicionales que desees compartir</li>
                            </ul>
                        </div>

                        <div>
                            <h3 className="text-white font-semibold mb-2">Datos de Navegación</h3>
                            <ul className="list-disc list-inside text-zinc-400 space-y-2">
                                <li><strong className="text-white">Cookies técnicas:</strong> Necesarias para el funcionamiento del sitio</li>
                                <li><strong className="text-white">Analítica anónima:</strong> Páginas visitadas, tiempo de permanencia</li>
                            </ul>
                        </div>
                    </section>

                    <section className="bg-surface border border-zinc-800 rounded-xl p-8">
                        <h2 className="text-xl font-bold text-white mb-4">3. Finalidades del Tratamiento</h2>
                        <p className="text-zinc-400 leading-relaxed">Los datos anónimos se utilizan para:</p>
                        <ul className="list-disc list-inside text-zinc-400 space-y-2 mt-4">
                            <li>Mejorar la experiencia del usuario en el sitio</li>
                            <li>Análisis estadístico de uso del portal</li>
                            <li>Optimización del rendimiento técnico</li>
                        </ul>
                    </section>

                    <section className="bg-surface border border-zinc-800 rounded-xl p-8">
                        <h2 className="text-xl font-bold text-white mb-4">4. Transferencia de Datos</h2>
                        <p className="text-zinc-400 leading-relaxed">
                            No vendemos, compartimos ni transferimos datos personales a terceros.
                            El sitio está alojado en Firebase (Google), sujeto a sus políticas de privacidad.
                        </p>
                    </section>

                    <section className="bg-surface border border-zinc-800 rounded-xl p-8">
                        <h2 className="text-xl font-bold text-white mb-4">5. Derechos ARCO</h2>
                        <p className="text-zinc-400 leading-relaxed">
                            Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse al tratamiento de sus datos.
                            Dado que no recopilamos datos personales identificables, estos derechos aplican
                            únicamente si nos contacta directamente.
                        </p>
                    </section>

                    <section className="bg-surface border border-zinc-800 rounded-xl p-8">
                        <h2 className="text-xl font-bold text-white mb-4">6. Contacto</h2>
                        <p className="text-zinc-400 leading-relaxed">
                            Para ejercer sus derechos ARCO o cualquier consulta relacionada con privacidad,
                            puede contactarnos en:
                        </p>
                        <p className="text-primary font-mono mt-4">
                            hello [arroba] quantified [punto] world
                        </p>
                    </section>

                    <section className="bg-surface border border-zinc-800 rounded-xl p-8">
                        <h2 className="text-xl font-bold text-white mb-4">7. Cambios al Aviso</h2>
                        <p className="text-zinc-400 leading-relaxed">
                            Nos reservamos el derecho de modificar este aviso. Cualquier cambio será publicado
                            en esta página con la fecha de actualización correspondiente.
                        </p>
                    </section>
                </div>

                {/* Footer */}
                <div className="mt-12 pt-8 border-t border-zinc-800 text-center">
                    <p className="text-zinc-600 font-mono text-sm">
                        Instituto de Innovación Iztacalco A.C. · i³
                    </p>
                </div>
            </div>
        </Layout>
    );
};

export default PrivacyPolicy;
